import React, { memo } from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";

const ReplyIcon = ({ className, width, height }) => {
  const classes = useStyles();

  return (
    <SvgIcon
      sx={{ width: width, height: height }}
      className={clsx(classes.icon, className)}
      viewBox="0 -960 960 960"
      fill="currentColor"
    >
      <path d="M760-200v-160q0-50-35-85t-85-35H273l144 144-57 56-240-240 240-240 57 56-144 144h367q83 0 141.5 58.5T840-360v160h-80Z" />
    </SvgIcon>
  );
};
ReplyIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
ReplyIcon.defaultProps = {
  width: 24,
  height: 24,
};
export default memo(ReplyIcon);

const useStyles = makeStyles(theme => ({
  icon: {
    transform: "scale(-1, 1)",
    color: theme.palette.primary.main,
  },
}));
